import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1384658"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-box h-full w-full overflow-y-auto max-w-14xl" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 登录 ", -1))
const _hoisted_3 = { class: "input-box" }
const _hoisted_4 = { class: "button-box" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 登 录 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 注 册 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 忘记密码？ ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_input = _resolveComponent("f-input")!
  const _component_f_button = _resolveComponent("f-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_f_input, {
        modelValue: _ctx.nameOrMail,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nameOrMail) = $event)),
        label: "用户名或邮箱",
        autofocus: "",
        clearable: "",
        outlined: "",
        required: "",
        hint: "与学校系统无关，请使用本站注册的账号~",
        rules: [(v) => !!v || '用户名不能为空']
      }, null, 8, ["modelValue", "rules"]),
      _createVNode(_component_f_input, {
        modelValue: _ctx.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
        type: "password",
        label: "密码",
        clearable: "",
        outlined: "",
        required: "",
        hint: "https 加密传输，后台不会存储明文密码",
        rules: [(v) => !!v || '密码不能为空'],
        onKeydown: _ctx.handleKeyDown
      }, null, 8, ["modelValue", "rules", "onKeydown"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_f_button, {
        class: "w-full",
        type: "primary",
        size: "large",
        shape: "circle",
        onClick: _ctx.login
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_f_button, {
        class: "w-full mt-4",
        type: "primary",
        size: "large",
        shape: "circle",
        ghost: "",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/register')))
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_f_button, {
      class: "mt-3",
      type: "link",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/forgot-password')))
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    })
  ]))
}